import { useMemo, useState } from "react";
import { useAppStore } from "../../store/app";
import {
  contactInitials,
  formatLastSeen,
  formatMessageTime,
  presenceFromLastSeen,
} from "../../types";
import { AvatarOrb } from "../ui/AvatarOrb";
import styles from "./InstanceList.module.css";

export function InstanceList() {
  const contacts = useAppStore((s) => s.contacts);
  const selectedAriaId = useAppStore((s) => s.selectedAriaId);
  const connectionPhase = useAppStore((s) => s.connectionPhase);
  const selectContact = useAppStore((s) => s.selectContact);
  const logout = useAppStore((s) => s.logout);
  const seedDemoData = useAppStore((s) => s.seedDemoData);
  const devMode = useAppStore((s) => s.devMode);
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return contacts;
    return contacts.filter(
      (c) =>
        c.name.toLowerCase().includes(q) ||
        c.ariaId.toLowerCase().includes(q) ||
        c.hostname?.toLowerCase().includes(q),
    );
  }, [contacts, query]);

  return (
    <div className={styles.wrap}>
      <div className={styles.header}>
        <div className={styles.titleBlock}>
          <h1>Instances</h1>
          <p>A.A.R.I.A.</p>
        </div>
      </div>

      <div className={styles.search}>
        <input
          type="search"
          placeholder="Search instances…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          aria-label="Search instances"
        />
      </div>

      <div className={styles.list}>
        {filtered.length === 0 ? (
          <p style={{ padding: "1rem", color: "var(--text-muted)", fontSize: "0.85rem" }}>
            No instances yet. Waiting for AARIA announce on MQTT…
          </p>
        ) : (
          filtered.map((c) => {
            const online = presenceFromLastSeen(c.lastSeenAt) === "online";
            const subtitle =
              c.lastMessage?.text ??
              (online ? "online" : formatLastSeen(c.lastSeenAt));
            return (
              <button
                key={c.ariaId}
                type="button"
                className={`${styles.row} ${selectedAriaId === c.ariaId ? styles.rowActive : ""}`}
                onClick={() => void selectContact(c.ariaId)}
              >
                <AvatarOrb initials={contactInitials(c.name)} online={online} />
                <div className={styles.body}>
                  <div className={styles.nameRow}>
                    <span className={styles.name}>{c.name}</span>
                    <span className={styles.time}>
                      {c.lastMessage
                        ? formatMessageTime(c.lastMessage.ts)
                        : ""}
                    </span>
                  </div>
                  <div
                    className={`${styles.preview} ${online && !c.lastMessage ? styles.onlineText : ""}`}
                  >
                    {c.typing ? "thinking…" : subtitle}
                  </div>
                </div>
                {c.unreadCount > 0 ? (
                  <span className={styles.badge}>{c.unreadCount}</span>
                ) : null}
              </button>
            );
          })
        )}
      </div>

      <div className={styles.footer}>
        <span>
          {connectionPhase === "connected" ? "● HiveMQ connected" : "○ disconnected"}
        </span>
        <span>
          {devMode ? (
            <button type="button" onClick={() => void seedDemoData()}>
              Demo data
            </button>
          ) : null}
          <button type="button" onClick={() => void logout()}>
            Logout
          </button>
        </span>
      </div>
    </div>
  );
}
